import styled from 'styled-components/macro';

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;

  & > * {
    margin-right: 20px;
    margin-bottom: 0;
  }
`;

export const RadioWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100px
`;
